import { Modify } from '../../utils/UtilityTypes';
import Currency from '../Currency';
import { SubsetOfFieldsFromFormattedService } from '../Api.types';

type ServiceToFormat = Modify<SubsetOfFieldsFromFormattedService<'cost' | 'total_duration_minutes'>, {
  cost: string | number;
}>;

export default function formatPriceAndDuration(
  service: ServiceToFormat,
  showAndUp: boolean = false,
  showMinutes: boolean = true,
): string {
  const duration = showMinutes ? `for ${
    service.total_duration_minutes
  } minutes` : '';
  return `${Currency.shortFormat(service.cost)}${showAndUp ? ' and up' : ''} ${duration}`;
}
